<template>
  <div class="min-height-100">
    <template v-if="isMobile">
      <mobile-filter-header :show-filters="() => setMobileFilterVisibility(true)" />
      <mobile-filter-panel
        :total-count="pagination.totalCount"
        :show="showMobileFilter"
        :hide-filters="() => setMobileFilterVisibility(false)"
      />
    </template>
    <div class="search-result-page">
      <filter-panel v-if="!isMobile" :total-count="pagination.totalCount"></filter-panel>
      <div class="page-content">
        <div class="page-header">
          <div class="page-title-row">
            <div class="page-title">Search Results</div>
            <sorting-options v-if="!isMobile" />
          </div>
          <h4 v-if="isMobile && pagination.totalCount" class="mobile-total-count color-gray">
            {{ pagination.totalCount }} TOTAL RESULTS
          </h4>
          <filter-badges class="filter-badges" />
        </div>
        <product-tiles :loading="loading" :products="products" :pagination="pagination" :set-page="setPage" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped src="../../assets/sass/searchPage/searchPage.scss"></style>

<script>
import { searchPageMobileStateHelper } from "../../components/mixin/search/searchPageMobileStateHelper";
import { FilterKeys } from "../../services/utils";
import { algoliaProductHelper } from "../../components/mixin/search/algoliaProductHelper";

export default {
  mixins: [algoliaProductHelper, searchPageMobileStateHelper],
  data() {
    return {
      filterOrSortUsed: false,
      filtersOrSortsUsed: new Set(),
      products: [],
      favoriteList: [],
    };
  },
  computed: {
    keyword: function () {
      return this.$route.query.keyword;
    },
  },
  watch: {
    "$route.query": function (query) {
      this.getProductsOnSearch(query);
    },
    "$route.query.keyword": function (keyword) {
      this.addKeywordToActiveFilters(keyword);
    },
  },
  async beforeMount() {
    await this.getFavouriteProducts();
    this.addKeywordToActiveFilters(this.$route.query.keyword);

    if (!this.$route.query.page) {
      this.updateURLParams("page", 1);
    } else {
      this.getProductsOnSearch(this.$route.query, { pageLevelCategoryFilter: this.categoryInfo });
    }
  },
  beforeDestroy() {
    this.$store.commit("filters/setFilters", { filterKey: FilterKeys.KEYWORD, activeFilters: [] });
  },
  methods: {
    addKeywordToActiveFilters,
  },
};

function addKeywordToActiveFilters(keyword) {
  this.$store.commit("filters/setFilters", {
    filterKey: FilterKeys.KEYWORD,
    activeFilters: keyword ? [{ label: keyword, value: keyword, selected: true }] : [],
  });
}
</script>
